<template>
  <svg
    class="w-5 h-5"
    viewBox="0 0 20 16"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_5199_3857)">
      <path
        d="M8.2 8.71875C7.49531 8.71875 7.15647 9.125 6 9.125C4.84353 9.125 4.50714 8.71875 3.8 8.71875C1.97812 8.71875 0.5 10.2473 0.5 12.1312V12.7812C0.5 13.4541 1.0279 14 1.67857 14H10.3214C10.9721 14 11.5 13.4541 11.5 12.7812V12.1312C11.5 10.2473 10.0219 8.71875 8.2 8.71875ZM10.3214 12.7812H1.67857V12.1312C1.67857 10.9227 2.63125 9.9375 3.8 9.9375C4.15848 9.9375 4.7404 10.3438 6 10.3438C7.26942 10.3438 7.83906 9.9375 8.2 9.9375C9.36875 9.9375 10.3214 10.9227 10.3214 12.1312V12.7812ZM6 8.3125C7.95201 8.3125 9.53571 6.6748 9.53571 4.65625C9.53571 2.6377 7.95201 1 6 1C4.04799 1 2.46429 2.6377 2.46429 4.65625C2.46429 6.6748 4.04799 8.3125 6 8.3125ZM6 2.21875C7.29888 2.21875 8.35714 3.31309 8.35714 4.65625C8.35714 5.99941 7.29888 7.09375 6 7.09375C4.70112 7.09375 3.64286 5.99941 3.64286 4.65625C3.64286 3.31309 4.70112 2.21875 6 2.21875Z"
      />
    </g>
    <path
      d="M18.7593 2.50631C17.8221 1.68774 16.374 1.8107 15.4773 2.75896C14.5805 1.8107 13.1324 1.68606 12.1952 2.50631C10.9757 3.57248 11.1541 5.31069 12.0233 6.232L14.8675 9.24186C15.0297 9.41366 15.247 9.50966 15.4773 9.50966C15.7091 9.50966 15.9248 9.41534 16.087 9.24354L18.9312 6.23369C19.7988 5.31237 19.9804 3.57416 18.7593 2.50631ZM18.3766 5.66439L15.5324 8.67425C15.4935 8.71467 15.461 8.71467 15.4221 8.67425L12.5779 5.66439C11.986 5.03783 11.866 3.85207 12.6962 3.12614C13.327 2.57537 14.3 2.6579 14.9097 3.30299C15.5194 3.94808 15.4773 3.90429 15.4773 3.90429L16.0448 3.30299C16.6578 2.65453 17.6307 2.57537 18.2583 3.12445C19.0869 3.85039 18.9637 5.04288 18.3766 5.66439Z"
    />
    <defs>
      <clipPath id="clip0_5199_3857">
        <rect
          width="12.0764"
          height="14.3407"
          transform="translate(0.371094 0.82959)"
        />
      </clipPath>
    </defs>
  </svg>
</template>
